import React, { Component, Fragment } from 'react';

import moment from 'moment';

class Formatter extends Component {
  render() {
    let formatString = this.props.format;
    let date = moment(this.props.value);
    if (!formatString) {
      formatString = 'DD/MM/YYYY HH:mm:ss';
      if (this.props.onlyDate) {
        formatString = 'DD/MM/YYYY';
      }
    }
    let value = date.isValid() && this.props.value ? date.format(formatString) : '';
    return (
      <Fragment>
        <span>{value}</span>
      </Fragment>
    );
  }
}

export default Formatter;
